import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Options } from '@angular-slider/ngx-slider';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
    selector: 'app-marketplace-filters',
    templateUrl: './marketplace-filters.component.html',
    styleUrls: ['./marketplace-filters.component.scss'],
})
export class MarketplaceFiltersComponent implements OnInit {
    @Input() form: FormGroup;
    @Input() numberOfresults: FormGroup;
    @Input() minimumPrice: number;
    @Input() maximumPrice: number;

    value: number = 40;
    highValue: number = 60;
    options: Options = {
        floor: 0,
        ceil: 100,
    };

    constructor(private overlayService: OverlayService) {}

    sliderForm: FormGroup;

    ngOnInit(): void {
        this.options.floor = this.minimumPrice;
        this.options.ceil = this.maximumPrice;
        this.sliderForm = new FormGroup({
            sliderControl: new FormControl([this.minimumPrice, this.maximumPrice]),
        });
        this.sliderForm.valueChanges.subscribe((values) => {
            debugger;
            this.form.controls.minPrice.setValue(values.sliderControl[0]);
            this.form.controls.maxPrice.setValue(values.sliderControl[1]);
        });
    }

    apply() {
        this.overlayService.toggle('marketplaceFilters');
    }

    close() {
        this.form.patchValue({
            type: null,
            sellUnit: null,
            minWidth: null,
            maxWidth: null,
            randomWidth: null,
            minLength: null,
            maxLength: null,
            randomLength: null,
            minThickness: null,
            maxThickness: null,
            minPrice: null,
            maxPrice: null,
            priceMethod: null,
        });
        this.overlayService.toggle('marketplaceFilters');
    }
}
